import { Address, CompanyDetails } from "../types/Types";

export function isCompanyDetails(
  obj: CompanyDetails | Address | null
): obj is CompanyDetails {
  return (obj as CompanyDetails)?.name !== undefined;
}
